export default function chunkArray(array, chunkSize) {

    const chunkedArray = [];

    for (let i=0, j=array.length; i<j; i+=chunkSize) {
        chunkedArray.push(array.slice(i, i + chunkSize))
    }
    return chunkedArray;
}
